module.exports = __webpack_public_path__ + "img/nuclei-02.64ebb70d.png";